export class TaskCommentObject {

  constructor(private author: string, private date: Date, private text: string) {

  }

  public getAuthor(): string {
    return this.author;
  }

  public getDate(): Date {
    return this.date;
  }

  public getText(): string {
    return this.text;
  }
}
